export const legacyMyInfo = {
  username: 'mock.user',
  name: 'Mock 직원',
  phone: '010-0000-0000',
  brand: 'Mock 브랜드',
  group: 'Mock 그룹',
  office: 'Mock 지점',
}
